﻿import { Collapsible } from './collapsible';

export const RangeSelector = function (rangeSelector, onOpened) {
    const self = this;

    const rangeDropdown = Collapsible(rangeSelector, onCollapsibleToggled);

    function onCollapsibleToggled(e) {
        if (e.isOpen) {
            if (typeof onOpened == "function") {
                onOpened(self);
            }
        }
    }

    function close() {
        rangeDropdown.close();
    }

    return {
        close: close
    };
};

RangeSelector.selectors = {
    root: "[data-component='range-selector']",
};